import { EnvironmentService } from '../_services/environment.service';

export const EnvironmentServiceFactory = () => {
  // Create Environment Variable
  const environment = new EnvironmentService();

  // Read Environment Variables from browser
  const browserWindow = window || {};
  const environmentKey = '__env';
  const broswerWindowEnvironment = browserWindow[environmentKey] || {};

  for (const key in broswerWindowEnvironment) {
    if (broswerWindowEnvironment.hasOwnProperty(key)) {
      environment[key] = window[environmentKey][key];
    }
  }

  return environment;
};

export const EnvironmentServiceProvider = {
  provide: EnvironmentService,
  useFactory: EnvironmentServiceFactory,
  deps: []
};
